module.exports = __webpack_public_path__ + "img/radioActive.0599189f.svg";